import { styled } from '@mui/material';
import { AriaRole, ReactNode } from 'react';

import { UserIcon } from '@app-velocity/icons';

const StyledUserCard = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  cursor: 'pointer',
  padding: theme.spacing(4),
  overflow: 'hidden',
  svg: {
    fill: 'var(--icon-icon-secondary-color)',
  },
}));

const IconBackground = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: theme.spacing(6),
  height: theme.spacing(6),
  background: '#D9D9D9',
  borderRadius: '50%',
  flex: '0 0 auto',
}));

const UserEmail = styled('span')({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  fontSize: 'inherit',
  lineHeight: 'normal',
  fontWeight: 500,
});

export type UserCardProps = {
  email: string;
  role?: AriaRole;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  right?: ReactNode;
};

export const UserCard = ({
  email,
  role,
  className,
  right,
  onClick,
}: UserCardProps) => {
  return (
    <StyledUserCard role={role} onClick={onClick} className={className}>
      <IconBackground>
        <UserIcon />
      </IconBackground>
      <UserEmail>{email}</UserEmail>
      {right}
    </StyledUserCard>
  );
};
